module.exports = __webpack_public_path__ + "static/logos_sprite-c0e1698ce42e5eb3855caddfb4360d0f.png";